export default {"src":"/_next/static/image/public/images/bg_blue_trash.b248a5b6b26c12ba65a62918cd2903f6.svg","height":30,"width":30};